export default {
  title: "لوحة التحكم",
  welcome: "مرحباً",
  overview: "نظرة عامة",
  statistics: "الإحصائيات",
  recentActivity: "النشاط الأخير",
  quickActions: "إجراءات سريعة",
  dashboard: "لوحة التحكم",
  dashboardSubtitle: "نظرة شاملة على أداء الشركة",
  refreshData: "تحديث البيانات",
  lastUpdated: "آخر تحديث",
  errorLoadingData: "خطأ في تحميل البيانات",
  retry: "إعادة المحاولة",
  loadingData: "جاري تحميل البيانات...",
  gatheringInfo: "نحن نجمع أحدث المعلومات لك",
  statisticsTitle: "الإحصائيات الرئيسية",
  statisticsSubtitle: "نظرة سريعة على أهم المؤشرات",
  todayTasks: "مهام اليوم الروتينية",
  reported: "مُبلغ عنها",
  task: "مهمة",
  totalTasks: "إجمالي المهام",
  done: "منجز",
  notDone: "غير منجز",
  notReported: "لم يُبلغ عنها",
  viewDetails: "عرض التفاصيل",
  oneTimeTasks: "مهام لمرة واحدة",
  urgent: "عاجلة",
  openTasks: "مهام مفتوحة",
  inProgress: "قيد التنفيذ",
  review: "قيد المراجعة",
  dueToday: "مستحقة اليوم",
  dueSoon: "مستحقة قريبًا",
  overdue: "متأخرة",
  projects: "المشاريع",
  active: "نشط",
  stopped: "متوقف",
  inActive: "غير نشط",
  employees: "الموظفين",
  pending: "معلق",
  performanceTrends: "اتجاهات الأداء",
  performanceTrendsSubtitle: "المهام المفتوحة والمراجعة والمنجزة عبر الزمن",
  aiAnalysis: "التحليل الذكي",
  aiAnalysisTitle: "تحليل ذكي لأداء الشركة",
  aiAnalysisSubtitle: "تحليل شامل للبيانات باستخدام الذكاء الاصطناعي",
  refresh: "تحديث",
  analyzingLatestData: "جاري تحليل أحدث البيانات...",
  gatheringInsights: "جمع رؤى ذكية من بياناتك",
  lastAnalyzed: "آخر تحليل",
  close: "إغلاق",
  reanalyze: "إعادة التحليل",
  quickAddTask: "إضافة سريعة",
  quickAddRoutineTask: "إضافة مهمة روتينية",
  quickAddOneTimeTask: "إضافة مهمة لمرة واحدة",
  taskName: "اسم المهمة",
  description: "الوصف",
  assignTo: "تعيين إلى",
  selectAssignee: "اختر المكلف",
  selectDepartment: "اختر القسم",
  selectTaskType: "اختر نوع المهمة",
  selectPriority: "اختر الأولوية",
  selectProject: "اختر المشروع",
  startDate: "تاريخ البدء",
  endDate: "تاريخ الانتهاء",
  deadline: "الموعد النهائي",
  priority: "الأولوية",
  project: "المشروع",
  taskType: "نوع المهمة",
  daily: "يومي",
  weekly: "أسبوعي",
  monthly: "شهري",
  high: "عالية",
  normal: "عادية",
  medium: "متوسطة",
  low: "منخفضة",
  cancel: "إلغاء",
  create: "إنشاء",
  saving: "جاري الحفظ...",
  fillRequiredFields: "يرجى ملء جميع الحقول المطلوبة",
  validationError: "خطأ في التحقق",
  success: "نجح",
  error: "خطأ",
  routineTaskAdded: "تم إضافة المهمة الروتينية بنجاح",
  oneTimeTaskAdded: "تم إضافة المهمة بنجاح",
  routineTaskAddedError: "خطأ في إضافة المهمة الروتينية",
  oneTimeTaskAddedError: "خطأ في إضافة المهمة",
  enterTaskName: "أدخل اسم المهمة",
  enterDescription: "أدخل الوصف",
  searchEmployees: "ابحث عن الموظفين",
  searchProjects: "ابحث عن المشاريع",
  clickToAddPeople: "اضغط لإضافة موظفين",
  clickToEdit: "اضغط للتعديل",
  lastDayOfMonth: "آخر يوم من الشهر",
  selectLastDayOfMonth: "اختر آخر يوم من الشهر",
  selectDays: "اختر الأيام",
  selectDaysOfWeek: "اختر أيام الأسبوع",
  dayOfMonth: "يوم الشهر",
  selectDayOfMonth: "اختر يوم الشهر",
  monday: "الاثنين",
  tuesday: "الثلاثاء",
  wednesday: "الأربعاء",
  thursday: "الخميس",
  friday: "الجمعة",
  saturday: "السبت",
  sunday: "الأحد",
  scrollToSeeMore: "اسحب لمشاهدة المزيد",
  from: "من",
  to: "إلى",
  enterStartDate: "أدخل تاريخ البدء",
  enterEndDate: "أدخل تاريخ الانتهاء",
  selectSupervisor: "اختر المشرف",
  selectInformer: "اختر المبلغ",
  selectConsultant: "اختر المستشار",
  searchPriorities: "ابحث عن الأولويات",
  noResultsFound: "لم يتم العثور على نتائج",
  taskProgressByDept: "تقدم المهام حسب القسم",
  taskProgressSubtitle: "مقارنة المهام المنجزة وغير المنجزة",
  reportsStatus: "حالة التقارير",
  reportsStatusSubtitle: "المهام المُبلغ عنها وغير المُبلغ عنها",
  undefined: "غير محدد",
  // Charts section
  chartsTitle: "الرسوم البيانية والتحليلات",
  chartsSubtitle: "تصور مرئي لأداء الأقسام والمهام",
  // Tables section
  tablesTitle: "البيانات التفصيلية",
  tablesSubtitle: "تفاصيل المهام والموظفين حسب الأقسام",
  dailyTasksByDept: "المهام اليومية حسب القسم",
  dailyTasksSubtitle: "تفصيل أداء كل قسم في المهام اليومية",
  employeesByDept: "الموظفين حسب القسم",
  employeesSubtitle: "توزيع الموظفين على الأقسام",
  // Table headers
  department: "القسم",
  reportedTasks: "المُبلغ عنها",
  notReportedTasks: "لم يُبلغ عنها",
  completionRate: "معدل الإنجاز",
  count: "العدد",
  // Navigation buttons
  prevChart: "السابق",
  nextChart: "التالي",
  clickToViewRoutineTasks: "اضغط لعرض المهام الروتينية",
  clickToViewOneTimeTasks: "اضغط لعرض المهام لمرة واحدة",
  clickToViewProjects: "اضغط لعرض المشاريع",
  clickToViewTeam: "اضغط لعرض الفريق/الموظفين",
  // Status
  stable: "مستقر",
  charts: {
    performance: "مخطط الأداء",
    tasks: "مخطط المهام",
    projects: "مخطط المشاريع",
    users: "مخطط المستخدمين",
  },
  cards: {
    totalTasks: "إجمالي المهام",
    completedTasks: "المهام المكتملة",
    pendingTasks: "المهام المعلقة",
    totalProjects: "إجمالي المشاريع",
    activeProjects: "المشاريع النشطة",
    totalUsers: "إجمالي المستخدمين",
    activeUsers: "المستخدمين النشطين",
  },
};
